import { walletService } from "@/libs/ws/Seller/walletService";
import Vuex from "vuex";

export default new Vuex.Store({
  state: {
    sidebar: {
      open: true,
      drawer: true,
    },
    config: {
      items_per_page: 10,
    },
    pageTitle: {
      page_title: [],
    },
    user: {
      balance: 0,
      loadingBalance: false,
      seller_info: null,
    },
  },
  mutations: {
    setOpenSidebar: function (state, payload) {
      if (payload.open != undefined) state.sidebar.open = payload.open;

      if (payload.drawer != undefined) state.sidebar.drawer = payload.drawer;
    },
    setPageTitle: function (state, payload) {
      state.pageTitle.page_title = payload.pageTitle;
    },
    setBalance: function (state, { balance, seller_info = null }) {
      state.user.balance = parseFloat(balance) || 0;
      state.user.seller_info = seller_info;
    },
    setLoadingBalance: function (state, loading) {
      state.user.loadingBalance = loading;
    },
  },
  actions: {
    async loadBalance({ commit }, params = null) {
      commit("setLoadingBalance", true);

      commit('setBalance', { balance: 0, seller_info: null });

      try {
        const response = await walletService.getBalance(params);
        if (response.status) {
          const balance = parseFloat(response.result.balance_account || 0);
          const seller_info = response.result.seller_info || null;
          console.log("seller info in store", seller_info);
          commit("setBalance", { balance, seller_info });
          return balance;
        } else {
          console.error("Error al cargar balance:", response.message);
          commit("setBalance", { balance: 0, seller_info: null });
          return 0;
        }
      } catch (error) {
        console.error("Error al cargar balance:", error);
        commit("setBalance", { balance: 0, seller_info: null });
        return 0;
      } finally {
        commit("setLoadingBalance", false);
      }
    },

    initializeUserBalance({ commit }) {
      const storedBalance = localStorage.getItem("user_balance");
      if (storedBalance) {
        commit("setBalance", parseFloat(storedBalance));
      }
    },
  },
  modules: {},
});
